import React, { useRef } from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import Loading from 'core/Loading';
import { useListingManagerRoutes } from 'modules/shared-menu/hooks/useListingManagerRoutes';

import { ADD_TO_OFFERS_PATHNAME, BROWSE_IMAGES_PATHNAME, EDIT_IMAGES_PATHNAME } from './constants';
import { ImageGalleryContextProvider } from './contexts/ImageGalleryContext';
import { useListingManagerImageGalleryFeatureFlag } from './hooks/useListingManagerImageGalleryFeatureFlag';
import { AddToOffersPage } from './pages/AddToOffersPage';
import { BrowseImagesPage } from './pages/BrowseImagesPage';
import { EditImagesPage } from './pages/EditImagesPage';
import { useOfferDraftChanges } from './useOfferDraftChanges';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const Main = styled.div`
  flex: 1;
  overflow: auto;
`;

export const ListingManagerImageGalleryPage = () => {
  const { rootPage } = useListingManagerRoutes();
  const { path } = useRouteMatch();
  const mainElementRef = useRef<HTMLDivElement>(null);
  const { isLoading, isListingManagerImageGalleryEnabled } = useListingManagerImageGalleryFeatureFlag();
  const { updateOfferDraftChanges, offerDraftChanges, offersWithDraftChanges, resetDraftChanges } =
    useOfferDraftChanges();

  if (isLoading) {
    return <Loading />;
  }

  return isListingManagerImageGalleryEnabled ? (
    <ImageGalleryContextProvider>
      <Root>
        <Switch>
          <Route path={`${path}/${BROWSE_IMAGES_PATHNAME}`} exact key={BROWSE_IMAGES_PATHNAME}>
            <Main ref={mainElementRef}>
              <BrowseImagesPage />
            </Main>
          </Route>
          <Route path={`${path}/${EDIT_IMAGES_PATHNAME}`} exact key={EDIT_IMAGES_PATHNAME}>
            <Main ref={mainElementRef}>
              <EditImagesPage />
            </Main>
          </Route>
          <Route path={`${path}/${ADD_TO_OFFERS_PATHNAME}`} exact key={ADD_TO_OFFERS_PATHNAME}>
            <Main ref={mainElementRef}>
              <AddToOffersPage
                updateOfferDraftChanges={updateOfferDraftChanges}
                offerDraftChanges={offerDraftChanges}
                offersWithDraftChanges={offersWithDraftChanges}
                resetDraftChanges={resetDraftChanges}
              />
            </Main>
          </Route>
        </Switch>
      </Root>
    </ImageGalleryContextProvider>
  ) : (
    <Redirect to={rootPage()} />
  );
};
